import Loader from "components/Loader/Loader";
import { useProjectOptions }
  from "Dashboard/hooks/ProjectsOptions";
import { useEmployeeOptions }
  from "Dashboard/scenes/HumanResources/hooks/EmployeeOptions";
import { useAppDispatch } from "hooks/hooks";
import { debounce } from "lodash";
import { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import { IIncident } from "../domain/IIncident";
import { IIncidentUpdate } from "../domain/IIncidentUpdate";
import { useIncidentTypeOptions } from "../hooks/IncidentTypeOptions";
import {
  getAllIncidentsForEmployee,
  selectState,
  setIncident,
} from "../incident.slice";
import { incidentsService } from "../services/incidents.service";
import TableRow from "./TableRow";
import DeleteIncidentModal from "./DeleteIncidentModal";
import { debounceTimeout } from "utils/debounceUtil";

const TableContent = () => {
  const { incidents, incidentTypes, loading } = useSelector(selectState);
  const dispatch = useAppDispatch();
  const projectOptions = useProjectOptions({ showHiddenInDropDowns: false });
  const employeeOptions = useEmployeeOptions();
  const { incidentTypeOptions, setIncidentTypeOptions } =
    useIncidentTypeOptions();

  useEffect(() => {
    dispatch(getAllIncidentsForEmployee());
  }, []);

  const delayedUpdateIncidentForWorkingEmployee = useCallback(
    debounce(async (data: IIncidentUpdate) => {
      try {
        await incidentsService.updateIncidentForWorkingEmployee(data);
        dispatch(setIncident(data));
      } catch (err) {
        console.log(err);
        let oldValue = await incidentsService.getAllIncidentsInPeriodForEmployee(undefined)
        dispatch(setIncident(oldValue.incidents[data.incidentId]))
        //TODO: if request fails reset state to old value
      }
    }, debounceTimeout),
    []
  );

  const updateIncident = async (data: IIncidentUpdate) => {
    delayedUpdateIncidentForWorkingEmployee(data);
  };

  return (
    <>
      <div className="g-grid g-content">
        {loading && <Loader />}
        {incidents.map((incident: IIncident, index: number) => (
          <TableRow
            incidentTypes={incidentTypes}
            incident={incident}
            key={index}
            index={index}
            projects={projectOptions}
            employees={employeeOptions}
            incidentTypeOptions={incidentTypeOptions}
            setIncidentTypeOptions={setIncidentTypeOptions}
            updateIncident={updateIncident}
          />
        ))}
      </div>
      <DeleteIncidentModal incidentTypes={incidentTypeOptions} />
    </>
  );
};

export default TableContent;


